export function getExtendedDialogState(state: { visible: boolean; animating: boolean }) {
  return {
    isFullyOpened: state.visible && !state.animating,
    isFullyClosed: !state.visible && !state.animating,
  }
}
